/**
 * The "Create a Post" card lives in the sidebar, which now also rides alongside a single post --
 * where there is no submission form to open. That button routes back to the feed and leaves the
 * intent here for the feed to pick up on its first render, the way comment-entry hands a pending
 * scroll to the post page.
 */
const PENDING_TTL_MS = 10_000;

let pendingUntil = 0;

export const requestSubmissionForm = (): void => {
  pendingUntil = Date.now() + PENDING_TTL_MS;
};

export const consumeSubmissionRequest = (): boolean => {
  const pending = Date.now() < pendingUntil;
  pendingUntil = 0;
  return pending;
};
